import MTreeSelect from './TreeSelect.vue';

export default MTreeSelect;
